import { v4 } from '@lukeed/uuid';
export async function appendFileList(fileCollection, fileList) {
    for (const file of fileList) {
        const source = {
            uuid: v4(),
            name: file.name,
            size: file.size,
            baseURL: 'ium:/',
            //@ts-expect-error We allow file.path as alternative to webkitRelativePath
            relativePath: file.webkitRelativePath || file.path || file.name,
            lastModified: file.lastModified,
            text: () => file.text(),
            arrayBuffer: () => file.arrayBuffer(),
            stream: () => file.stream(),
        };
        await fileCollection.appendExtendedSource(source);
    }
}
//# sourceMappingURL=appendFileList.js.map